import {Field, ErrorMessage, getIn} from 'formik'
import React from 'react'
import {Form as BSForm} from 'react-bootstrap'

function FormikInput({
  type = 'text',
  name,
  onChange,
  label,
  className = 'mb-9',
  size = 'md',
  required = false,
  ErrorFeedback,
  validityClass,
  fontSize,
  color,
  fontWeight,
  children,
  ...props
}) {
  return (
    <BSForm.Group className={className} controlId={name}>
      <Field name={name}>
        {({field, form: {errors, values, touched}}) => (
          <>
            <label className="form-label fs-6 fw-bold">
              {label || name}
              {required && (
                <span
                  className={`ms-1 ${validityClass(
                    getIn(errors, name),
                    getIn(values, name),
                    getIn(touched, name)
                  )}`}
                >
                  *
                </span>
              )}
            </label>

            <input
              {...field}
              className={'form-control mb-0 border-gray-400 ' + 'form-control-' + size}
              required={required}
              type={type}
              {...props}
              onChange={(e) => {
                if (onChange) {
                  onChange(e)
                  return
                }
                field.onChange(e)
              }}
              autoComplete="off"
            />
          </>
        )}
      </Field>

      <ErrorMessage name={name} component={ErrorFeedback} />
    </BSForm.Group>
  )
}

export default FormikInput
